import { useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import { lighten } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { connect } from "react-redux";

import { NAV_DRAWER_COLLAPSED_WIDTH, NAV_DRAWER_EXPANDED_WIDTH } from "./portalNavDrawer";

const CustomizedComponent = styled(Grid)(({ theme }) => ({
  position: "relative",
  paddingBottom: 0,
  // paddingBottom: theme.spacing(1),
  overflowY: "auto",
  marginTop: "64px", //height of the portalAppBar
  "&::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&:hover::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: theme.palette.commonground,
    backgroundClip: "content-box",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  "&::-webkit-scrollbar-thumb": {
    opacity: "0.5",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
  },
}));

const PortalGridContent = props => {
  const {
    children,
    hasPortalAppBar = true,
    hasNavDrawer = false,
    navDrawerOpen = false,
    sx,
    ...other
  } = props;

  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  // Offset content by the drawer's current width so the expanded drawer pushes
  // the widgets over instead of covering them.
  const drawerWidth = navDrawerOpen ? NAV_DRAWER_EXPANDED_WIDTH : NAV_DRAWER_COLLAPSED_WIDTH;

  return (
    <CustomizedComponent
      container
      padding={mobileLayout ? "2px" : theme.spacing(1)}
      marginTop={hasPortalAppBar ? "64px" : theme.spacing(1)} //height of the portalAppBar
      marginLeft={hasNavDrawer ? `${drawerWidth}px` : 0}
      width={hasNavDrawer ? `calc(100% - ${drawerWidth}px)` : undefined}
      spacing={mobileLayout ? 0 : 2}
      sx={{
        transition: theme.transitions.create(["margin-left", "width"], {
          easing: theme.transitions.easing.sharp,
          duration: navDrawerOpen
            ? theme.transitions.duration.enteringScreen
            : theme.transitions.duration.leavingScreen,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </CustomizedComponent>
  );
};

const mapStateToProps = state => ({
  navDrawerOpen: state.userSession.navDrawerOpen,
});

export default connect(mapStateToProps)(PortalGridContent);
